// extracted by mini-css-extract-plugin
export var actionButton = "_oq-0";
export var actionMenuContainer = "_oq-i";
export var bubble = "_oq-2";
export var bubbleActionMenu = "_oq-j";
export var bubbleContext = "_oq-6";
export var bubbleItems = "_oq-7";
export var customer = "_oq-3";
export var divider = "_oq-8";
export var fileList = "_oq-9";
export var hiddenComment = "_oq-o";
export var infoAbove = "_oq-a";
export var internal = "_oq-4";
export var lightActionButton = "_oq-1";
export var link = "_oq-b";
export var merchant = "_oq-5";
export var message = "_oq-c";
export var profilePicture = "_oq-e";
export var quillToolbarContainer = "_oq-f";
export var senderDate = "_oq-g";
export var senderDateCustomer = "_oq-h";
export var senderName = "_oq-d";
export var time = "_oq-k";
export var uploadedImage = "_oq-l";
export var username = "_oq-m";
export var xsmall = "_oq-n";